import { commonEnv } from './environment.common';

const env: Partial<typeof commonEnv> = {
  staging: true,
  APP_SERVICES_URL: 'https://api.qa.machool.com/REST-app-services/api/v1',
  ESPRESSO_URL: 'https://espresso.qa.machool.com',
  INTEGRATION_SERVICES_URL: 'https://api.qa.machool.com/REST-integration-services/api/v1',
  UTILITY_SERVICES_URL: 'https://api.qa.machool.com/REST-utility-services/api/v1',
  TIMESERIES_SERVICES_URL: 'https://api.qa.machool.com/REST-timeseries-services/api/v1',
  firebaseTenantID: 'qa-admin-panel-4x8jq',
};

export const environment = Object.assign(commonEnv, env);
